module.exports = __webpack_public_path__ + "static/media/S (157).5453da81.jpg";